import { createContext, useContext } from "react"
import { LayoutVariation } from "./types"

export const LayoutContext = createContext<{ variation?: LayoutVariation }>({
  variation: undefined,
})

export const useLayoutContext = () => useContext(LayoutContext)
